import { FLOW_DESIGNER_CLOSE } from 'actions/flowDesigner';
import {
  FBI_FETCH_PLAN_CONSTANT_START,
  FBI_FETCH_PLAN_CONSTANT_SUCCESS,
  FBI_FETCH_PLAN_CONSTANT_FAILURE,
  FBI_FETCH_PLAN_ENDPOINT_START,
  FBI_FETCH_PLAN_ENDPOINT_SUCCESS,
  FBI_FETCH_PLAN_ENDPOINT_FAILURE,
} from 'actions/flowBlockInput';

export const INITIAL_STATE = {
  error: null,
  planConstantsFetchFinish: false,
  planPropertiesFetchFinish: false,
  planEndpointFetchFinish: false,
};

export default function loadStateReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FBI_FETCH_PLAN_ENDPOINT_START:
      return {
        ...state,
        error: null,
        planEndpointFetchFinish: false,
      };
    case FBI_FETCH_PLAN_ENDPOINT_SUCCESS:
      return {
        ...state,
        error: null,
        planEndpointFetchFinish: true,
      };
    case FBI_FETCH_PLAN_ENDPOINT_FAILURE:
      return {
        ...state,
        error: action.payload,
        planEndpointFetchFinish: true,
      };
    case FBI_FETCH_PLAN_CONSTANT_START:
      return {
        ...state,
        error: null,
        planConstantsFetchFinish: false,
      };
    case FBI_FETCH_PLAN_CONSTANT_SUCCESS:
      return {
        ...state,
        error: null,
        planConstantsFetchFinish: true,
      };
    case FBI_FETCH_PLAN_CONSTANT_FAILURE:
      return {
        ...state,
        error: action.payload,
        planConstantsFetchFinish: true,
      };
    case FLOW_DESIGNER_CLOSE:
      return INITIAL_STATE;
    default:
      return state;
  }
}
